import React from "react";
import PieChart from "../piechart";

const Gender = ({ HighchartsReact, Highcharts, data }) => {
  return (
    <>
      <PieChart
        title={"Gender"}
        data={data}
        Highcharts={Highcharts}
        HighchartsReact={HighchartsReact}
      />
    </>
  );
};

export default Gender;
